'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _Input = require('../../Input');

var _Input2 = _interopRequireDefault(_Input);

var _INumber = require('../../../common/iObjects/INumber');

var _INumber2 = _interopRequireDefault(_INumber);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formatFunction = function formatFunction() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var valString = new _INumber2.default(value).toString(null, null, true);

    // не нужно дописывать 0, если пользователь ввел число формата 12.2
    if (/[.,][1-9]{1}$/.test(value)) {
        valString = valString.slice(0, -1);
    }

    // 12.0 при оборачивании в INumber превращается в 12
    if (/[.,]0{1}$/.test(value)) {
        valString = value;
    }

    // 12. | 12, при оборачивании в INumber превращается в 12
    if (/[.,]{1}$/.test(value)) {
        valString = value;
    }

    return valString;
};

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Main.__proto__ || Object.getPrototypeOf(Main)).call.apply(_ref, [this].concat(args))), _this), _this._format = function () {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (typeof _this.props.format === 'function') {
                return _this.props.format(value);
            } else {
                return formatFunction(value);
            }
        }, _this._stringify = function () {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (typeof _this.props.stringify === 'function') {
                return _this.props.stringify(value);
            } else {
                if (value instanceof _INumber2.default) {
                    return value.toString(null, null, true);
                } else {
                    return _this._format(value);
                }
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'render',
        value: function render() {
            var props = {};

            // data bind keeps value in own HOC
            if (this.props.bind) {
                props.format = this._format;
                props.stringify = this._stringify;
            } else {
                // controlled component keeps value in parent state
                props.value = this._stringify(this.props.value);
            }

            return _react2.default.createElement(_Input2.default, _extends({}, this.props, props));
        }
    }]);

    return Main;
}(_Component3.default);

Main.defaultProps = {
    placeholder: '200.00',
    valueOfOptions: [null, null, true],
    // 9 999 999 by default 9 digits with spaces
    maxLength: 9,
    floating: false
};
Main.propTypes = {
    elementRef: _propTypes2.default.func,
    format: _propTypes2.default.func,
    stringify: _propTypes2.default.func,
    bind: _propTypes2.default.bool,
    value: _propTypes2.default.any
};
Main.displayName = 'NumberInput';
exports.default = Main;